import React, { useEffect } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { MODES } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "app/containers/Questions/redux/slice";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import { TrueFalseAnswer } from "app/containers/Questions/types";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Radio, Typography } from "@mui/material";

const initialData: TrueFalseAnswer[] = [
  {
    _id: "",
    answer: "",
  },
];

const TrueFalse = ({
  disabled,
  mode,
}: {
  disabled?: boolean;
  mode: MODES;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const answer = useSelector(selectAnswer);

  useEffect(() => {
    dispatch(actions.setTrueFalseAnswer(initialData));
  }, [mode, dispatch]);

  const setAnswer = (selectedAnswer: "TRUE" | "FALSE") => {
    dispatch(
      actions.setUpdateIsCorrectAnswer({
        index: 0,
        type: "true_false",
        key: "answer",
        value: selectedAnswer,
      })
    );
  };

  const isTrue = (answer?.true_false?.[0]?.answer ?? "") === "TRUE";
  const isFalse = (answer?.true_false?.[0]?.answer ?? "") === "FALSE";
  return (
    <Grid2
      container
      spacing={3}
      sx={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "200px",
        marginTop: "10px",
        marginLeft: "5px",
        marginRight: "5px",
      }}
    >
   
        <FormControlLabel
          disabled={disabled}
          onClick={() => {
            if(disabled){ return}
            setAnswer("TRUE")
          }}
          value="TRUE"
          control={
            <Radio
              size="small"
              checked={isTrue}
              disabled={disabled}
              sx={{
                color: "#207DB9",
                "&.Mui-checked": {
                  color: "#207DB9",
                },
              }}
            />
          }
          label={
            <Typography
              sx={{
              
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              {t("QUESTIONS.FORM.LABELS.TRUE_STATEMENT")}
            </Typography>
          }
          sx={{ marginRight: 0, marginBottom: 0 }}
        />
     
        <FormControlLabel
          disabled={disabled}
          onClick={() => {
            if(disabled){ return}
            setAnswer("FALSE")
          }}
          value="FALSE"
          control={
            <Radio
              size="small"
              checked={isFalse}
              disabled={disabled}
              sx={{
                color: "#207DB9",
                "&.Mui-checked": {
                  color: "#207DB9",
                },
              }}
            />
          }
          label={
            <Typography
              sx={{
               
                fontSize: "12px",
                textTransform: "capitalize",
              }}
            >
              {t("QUESTIONS.FORM.LABELS.FALSE_STATEMENT")}
            </Typography>
          }
          sx={{ marginRight: 0, marginBottom: 0 }}
        />

    </Grid2>
  );
};

export default TrueFalse;
